import http from './http'

export default {
  register (payload) {
    // POST /users  body: { email, firstName, lastName, phoneNumber, password, oneTimePin }
    return http.post('/users', payload)
  },
  login (payload) {
    // POST /users/login  body: { email, password }
    return http.post('/users/login', payload)
  },
  refreshToken () {
    return http.get('/users/refresh-token')
  },
  verifyAccount (payload) {
    // PATCH /users/verify-account  body: { email, otp }
    return http.patch('/users/verify-account', payload)
  },
  resendOtp (payload) {
    // PATCH /users/resend-otp  body: { phoneNumber }
    return http.patch('/users/resend-otp', payload)
  },
  forgotPassword (payload) {
    return http.post('/users/forgot-password', payload)
  },
  resetPassword (payload) {
    return http.post('/users/reset-password', payload)
  },
  getCurrentUser () {
    return http.get('/users')
  },
  deleteAccount (payload) {
    return http.post('/users/delete-account', payload)
  }
}
